<div class="item-wrapper" [style.background]="'url(' + item.image + ')'">

</div>
